/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Grade_Delete_Blocked_PrefixInputs */

const vi_tea_grade_delete_blocked_prefix = /** @type {(inputs: Tea_Grade_Delete_Blocked_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thể xoá, đang được dùng bởi:`)
};

/**

* @param {Tea_Grade_Delete_Blocked_PrefixInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_grade_delete_blocked_prefix = /** @type {((inputs?: Tea_Grade_Delete_Blocked_PrefixInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Grade_Delete_Blocked_PrefixInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_grade_delete_blocked_prefix(inputs)
});